import { __assign } from "tslib";
export var __EndpointTypesElement;
(function (__EndpointTypesElement) {
    __EndpointTypesElement["ADM"] = "ADM";
    __EndpointTypesElement["APNS"] = "APNS";
    __EndpointTypesElement["APNS_SANDBOX"] = "APNS_SANDBOX";
    __EndpointTypesElement["APNS_VOIP"] = "APNS_VOIP";
    __EndpointTypesElement["APNS_VOIP_SANDBOX"] = "APNS_VOIP_SANDBOX";
    __EndpointTypesElement["BAIDU"] = "BAIDU";
    __EndpointTypesElement["CUSTOM"] = "CUSTOM";
    __EndpointTypesElement["EMAIL"] = "EMAIL";
    __EndpointTypesElement["GCM"] = "GCM";
    __EndpointTypesElement["PUSH"] = "PUSH";
    __EndpointTypesElement["SMS"] = "SMS";
    __EndpointTypesElement["VOICE"] = "VOICE";
})(__EndpointTypesElement || (__EndpointTypesElement = {}));
export var Action;
(function (Action) {
    Action["DEEP_LINK"] = "DEEP_LINK";
    Action["OPEN_APP"] = "OPEN_APP";
    Action["URL"] = "URL";
})(Action || (Action = {}));
export var ActivityResponse;
(function (ActivityResponse) {
    ActivityResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ActivityResponse || (ActivityResponse = {}));
export var ActivitiesResponse;
(function (ActivitiesResponse) {
    ActivitiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ActivitiesResponse || (ActivitiesResponse = {}));
export var AttributeType;
(function (AttributeType) {
    AttributeType["EXCLUSIVE"] = "EXCLUSIVE";
    AttributeType["INCLUSIVE"] = "INCLUSIVE";
})(AttributeType || (AttributeType = {}));
export var AttributeDimension;
(function (AttributeDimension) {
    AttributeDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AttributeDimension || (AttributeDimension = {}));
export var DimensionType;
(function (DimensionType) {
    DimensionType["EXCLUSIVE"] = "EXCLUSIVE";
    DimensionType["INCLUSIVE"] = "INCLUSIVE";
})(DimensionType || (DimensionType = {}));
export var SetDimension;
(function (SetDimension) {
    SetDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SetDimension || (SetDimension = {}));
export var MetricDimension;
(function (MetricDimension) {
    MetricDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MetricDimension || (MetricDimension = {}));
export var EventDimensions;
(function (EventDimensions) {
    EventDimensions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventDimensions || (EventDimensions = {}));
export var EventCondition;
(function (EventCondition) {
    EventCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventCondition || (EventCondition = {}));
export var SegmentCondition;
(function (SegmentCondition) {
    SegmentCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentCondition || (SegmentCondition = {}));
export var Duration;
(function (Duration) {
    Duration["DAY_14"] = "DAY_14";
    Duration["DAY_30"] = "DAY_30";
    Duration["DAY_7"] = "DAY_7";
    Duration["HR_24"] = "HR_24";
})(Duration || (Duration = {}));
export var RecencyType;
(function (RecencyType) {
    RecencyType["ACTIVE"] = "ACTIVE";
    RecencyType["INACTIVE"] = "INACTIVE";
})(RecencyType || (RecencyType = {}));
export var RecencyDimension;
(function (RecencyDimension) {
    RecencyDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RecencyDimension || (RecencyDimension = {}));
export var SegmentBehaviors;
(function (SegmentBehaviors) {
    SegmentBehaviors.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentBehaviors || (SegmentBehaviors = {}));
export var SegmentDemographics;
(function (SegmentDemographics) {
    SegmentDemographics.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentDemographics || (SegmentDemographics = {}));
export var GPSCoordinates;
(function (GPSCoordinates) {
    GPSCoordinates.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GPSCoordinates || (GPSCoordinates = {}));
export var GPSPointDimension;
(function (GPSPointDimension) {
    GPSPointDimension.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GPSPointDimension || (GPSPointDimension = {}));
export var SegmentLocation;
(function (SegmentLocation) {
    SegmentLocation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentLocation || (SegmentLocation = {}));
export var SegmentDimensions;
(function (SegmentDimensions) {
    SegmentDimensions.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentDimensions || (SegmentDimensions = {}));
export var SimpleCondition;
(function (SimpleCondition) {
    SimpleCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SimpleCondition || (SimpleCondition = {}));
export var Operator;
(function (Operator) {
    Operator["ALL"] = "ALL";
    Operator["ANY"] = "ANY";
})(Operator || (Operator = {}));
export var Condition;
(function (Condition) {
    Condition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Condition || (Condition = {}));
export var WaitTime;
(function (WaitTime) {
    WaitTime.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(WaitTime || (WaitTime = {}));
export var ConditionalSplitActivity;
(function (ConditionalSplitActivity) {
    ConditionalSplitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ConditionalSplitActivity || (ConditionalSplitActivity = {}));
export var JourneyCustomMessage;
(function (JourneyCustomMessage) {
    JourneyCustomMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(JourneyCustomMessage || (JourneyCustomMessage = {}));
export var CustomMessageActivity;
(function (CustomMessageActivity) {
    CustomMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CustomMessageActivity || (CustomMessageActivity = {}));
export var JourneyEmailMessage;
(function (JourneyEmailMessage) {
    JourneyEmailMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(JourneyEmailMessage || (JourneyEmailMessage = {}));
export var EmailMessageActivity;
(function (EmailMessageActivity) {
    EmailMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EmailMessageActivity || (EmailMessageActivity = {}));
export var HoldoutActivity;
(function (HoldoutActivity) {
    HoldoutActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(HoldoutActivity || (HoldoutActivity = {}));
export var MultiConditionalBranch;
(function (MultiConditionalBranch) {
    MultiConditionalBranch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MultiConditionalBranch || (MultiConditionalBranch = {}));
export var MultiConditionalSplitActivity;
(function (MultiConditionalSplitActivity) {
    MultiConditionalSplitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MultiConditionalSplitActivity || (MultiConditionalSplitActivity = {}));
export var JourneyPushMessage;
(function (JourneyPushMessage) {
    JourneyPushMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(JourneyPushMessage || (JourneyPushMessage = {}));
export var PushMessageActivity;
(function (PushMessageActivity) {
    PushMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PushMessageActivity || (PushMessageActivity = {}));
export var RandomSplitEntry;
(function (RandomSplitEntry) {
    RandomSplitEntry.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RandomSplitEntry || (RandomSplitEntry = {}));
export var RandomSplitActivity;
(function (RandomSplitActivity) {
    RandomSplitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RandomSplitActivity || (RandomSplitActivity = {}));
export var MessageType;
(function (MessageType) {
    MessageType["PROMOTIONAL"] = "PROMOTIONAL";
    MessageType["TRANSACTIONAL"] = "TRANSACTIONAL";
})(MessageType || (MessageType = {}));
export var JourneySMSMessage;
(function (JourneySMSMessage) {
    JourneySMSMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(JourneySMSMessage || (JourneySMSMessage = {}));
export var SMSMessageActivity;
(function (SMSMessageActivity) {
    SMSMessageActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SMSMessageActivity || (SMSMessageActivity = {}));
export var WaitActivity;
(function (WaitActivity) {
    WaitActivity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(WaitActivity || (WaitActivity = {}));
export var Activity;
(function (Activity) {
    Activity.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Activity || (Activity = {}));
export var ChannelType;
(function (ChannelType) {
    ChannelType["ADM"] = "ADM";
    ChannelType["APNS"] = "APNS";
    ChannelType["APNS_SANDBOX"] = "APNS_SANDBOX";
    ChannelType["APNS_VOIP"] = "APNS_VOIP";
    ChannelType["APNS_VOIP_SANDBOX"] = "APNS_VOIP_SANDBOX";
    ChannelType["BAIDU"] = "BAIDU";
    ChannelType["CUSTOM"] = "CUSTOM";
    ChannelType["EMAIL"] = "EMAIL";
    ChannelType["GCM"] = "GCM";
    ChannelType["PUSH"] = "PUSH";
    ChannelType["SMS"] = "SMS";
    ChannelType["VOICE"] = "VOICE";
})(ChannelType || (ChannelType = {}));
export var AddressConfiguration;
(function (AddressConfiguration) {
    AddressConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AddressConfiguration || (AddressConfiguration = {}));
export var ADMChannelRequest;
(function (ADMChannelRequest) {
    ADMChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ADMChannelRequest || (ADMChannelRequest = {}));
export var ADMChannelResponse;
(function (ADMChannelResponse) {
    ADMChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ADMChannelResponse || (ADMChannelResponse = {}));
export var ADMMessage;
(function (ADMMessage) {
    ADMMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ADMMessage || (ADMMessage = {}));
export var AndroidPushNotificationTemplate;
(function (AndroidPushNotificationTemplate) {
    AndroidPushNotificationTemplate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AndroidPushNotificationTemplate || (AndroidPushNotificationTemplate = {}));
export var APNSChannelRequest;
(function (APNSChannelRequest) {
    APNSChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSChannelRequest || (APNSChannelRequest = {}));
export var APNSChannelResponse;
(function (APNSChannelResponse) {
    APNSChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSChannelResponse || (APNSChannelResponse = {}));
export var APNSMessage;
(function (APNSMessage) {
    APNSMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSMessage || (APNSMessage = {}));
export var APNSPushNotificationTemplate;
(function (APNSPushNotificationTemplate) {
    APNSPushNotificationTemplate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSPushNotificationTemplate || (APNSPushNotificationTemplate = {}));
export var APNSSandboxChannelRequest;
(function (APNSSandboxChannelRequest) {
    APNSSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSSandboxChannelRequest || (APNSSandboxChannelRequest = {}));
export var APNSSandboxChannelResponse;
(function (APNSSandboxChannelResponse) {
    APNSSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSSandboxChannelResponse || (APNSSandboxChannelResponse = {}));
export var APNSVoipChannelRequest;
(function (APNSVoipChannelRequest) {
    APNSVoipChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSVoipChannelRequest || (APNSVoipChannelRequest = {}));
export var APNSVoipChannelResponse;
(function (APNSVoipChannelResponse) {
    APNSVoipChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSVoipChannelResponse || (APNSVoipChannelResponse = {}));
export var APNSVoipSandboxChannelRequest;
(function (APNSVoipSandboxChannelRequest) {
    APNSVoipSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSVoipSandboxChannelRequest || (APNSVoipSandboxChannelRequest = {}));
export var APNSVoipSandboxChannelResponse;
(function (APNSVoipSandboxChannelResponse) {
    APNSVoipSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(APNSVoipSandboxChannelResponse || (APNSVoipSandboxChannelResponse = {}));
export var ResultRowValue;
(function (ResultRowValue) {
    ResultRowValue.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResultRowValue || (ResultRowValue = {}));
export var ResultRow;
(function (ResultRow) {
    ResultRow.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ResultRow || (ResultRow = {}));
export var BaseKpiResult;
(function (BaseKpiResult) {
    BaseKpiResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BaseKpiResult || (BaseKpiResult = {}));
export var ApplicationDateRangeKpiResponse;
(function (ApplicationDateRangeKpiResponse) {
    ApplicationDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ApplicationDateRangeKpiResponse || (ApplicationDateRangeKpiResponse = {}));
export var ApplicationResponse;
(function (ApplicationResponse) {
    ApplicationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ApplicationResponse || (ApplicationResponse = {}));
export var Mode;
(function (Mode) {
    Mode["DELIVERY"] = "DELIVERY";
    Mode["FILTER"] = "FILTER";
})(Mode || (Mode = {}));
export var CampaignHook;
(function (CampaignHook) {
    CampaignHook.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignHook || (CampaignHook = {}));
export var CampaignLimits;
(function (CampaignLimits) {
    CampaignLimits.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignLimits || (CampaignLimits = {}));
export var QuietTime;
(function (QuietTime) {
    QuietTime.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(QuietTime || (QuietTime = {}));
export var ApplicationSettingsResource;
(function (ApplicationSettingsResource) {
    ApplicationSettingsResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ApplicationSettingsResource || (ApplicationSettingsResource = {}));
export var ApplicationsResponse;
(function (ApplicationsResponse) {
    ApplicationsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ApplicationsResponse || (ApplicationsResponse = {}));
export var AttributesResource;
(function (AttributesResource) {
    AttributesResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(AttributesResource || (AttributesResource = {}));
export var BadRequestException;
(function (BadRequestException) {
    BadRequestException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BadRequestException || (BadRequestException = {}));
export var BaiduChannelRequest;
(function (BaiduChannelRequest) {
    BaiduChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BaiduChannelRequest || (BaiduChannelRequest = {}));
export var BaiduChannelResponse;
(function (BaiduChannelResponse) {
    BaiduChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BaiduChannelResponse || (BaiduChannelResponse = {}));
export var BaiduMessage;
(function (BaiduMessage) {
    BaiduMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(BaiduMessage || (BaiduMessage = {}));
export var CampaignCustomMessage;
(function (CampaignCustomMessage) {
    CampaignCustomMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignCustomMessage || (CampaignCustomMessage = {}));
export var CampaignDateRangeKpiResponse;
(function (CampaignDateRangeKpiResponse) {
    CampaignDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignDateRangeKpiResponse || (CampaignDateRangeKpiResponse = {}));
export var CampaignEmailMessage;
(function (CampaignEmailMessage) {
    CampaignEmailMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignEmailMessage || (CampaignEmailMessage = {}));
export var FilterType;
(function (FilterType) {
    FilterType["ENDPOINT"] = "ENDPOINT";
    FilterType["SYSTEM"] = "SYSTEM";
})(FilterType || (FilterType = {}));
export var CampaignEventFilter;
(function (CampaignEventFilter) {
    CampaignEventFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignEventFilter || (CampaignEventFilter = {}));
export var CustomDeliveryConfiguration;
(function (CustomDeliveryConfiguration) {
    CustomDeliveryConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CustomDeliveryConfiguration || (CustomDeliveryConfiguration = {}));
export var Message;
(function (Message) {
    Message.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Message || (Message = {}));
export var CampaignSmsMessage;
(function (CampaignSmsMessage) {
    CampaignSmsMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignSmsMessage || (CampaignSmsMessage = {}));
export var MessageConfiguration;
(function (MessageConfiguration) {
    MessageConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MessageConfiguration || (MessageConfiguration = {}));
export var Frequency;
(function (Frequency) {
    Frequency["DAILY"] = "DAILY";
    Frequency["EVENT"] = "EVENT";
    Frequency["HOURLY"] = "HOURLY";
    Frequency["MONTHLY"] = "MONTHLY";
    Frequency["ONCE"] = "ONCE";
    Frequency["WEEKLY"] = "WEEKLY";
})(Frequency || (Frequency = {}));
export var Schedule;
(function (Schedule) {
    Schedule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Schedule || (Schedule = {}));
export var CampaignStatus;
(function (CampaignStatus) {
    CampaignStatus["COMPLETED"] = "COMPLETED";
    CampaignStatus["DELETED"] = "DELETED";
    CampaignStatus["EXECUTING"] = "EXECUTING";
    CampaignStatus["INVALID"] = "INVALID";
    CampaignStatus["PAUSED"] = "PAUSED";
    CampaignStatus["PENDING_NEXT_RUN"] = "PENDING_NEXT_RUN";
    CampaignStatus["SCHEDULED"] = "SCHEDULED";
})(CampaignStatus || (CampaignStatus = {}));
export var CampaignState;
(function (CampaignState) {
    CampaignState.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignState || (CampaignState = {}));
export var Template;
(function (Template) {
    Template.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Template || (Template = {}));
export var TemplateConfiguration;
(function (TemplateConfiguration) {
    TemplateConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TemplateConfiguration || (TemplateConfiguration = {}));
export var TreatmentResource;
(function (TreatmentResource) {
    TreatmentResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TreatmentResource || (TreatmentResource = {}));
export var CampaignResponse;
(function (CampaignResponse) {
    CampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignResponse || (CampaignResponse = {}));
export var CampaignsResponse;
(function (CampaignsResponse) {
    CampaignsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CampaignsResponse || (CampaignsResponse = {}));
export var ChannelResponse;
(function (ChannelResponse) {
    ChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ChannelResponse || (ChannelResponse = {}));
export var ChannelsResponse;
(function (ChannelsResponse) {
    ChannelsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ChannelsResponse || (ChannelsResponse = {}));
export var ConflictException;
(function (ConflictException) {
    ConflictException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ConflictException || (ConflictException = {}));
export var CreateApplicationRequest;
(function (CreateApplicationRequest) {
    CreateApplicationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateApplicationRequest || (CreateApplicationRequest = {}));
export var CreateAppRequest;
(function (CreateAppRequest) {
    CreateAppRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateAppRequest || (CreateAppRequest = {}));
export var CreateAppResponse;
(function (CreateAppResponse) {
    CreateAppResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateAppResponse || (CreateAppResponse = {}));
export var ForbiddenException;
(function (ForbiddenException) {
    ForbiddenException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ForbiddenException || (ForbiddenException = {}));
export var InternalServerErrorException;
(function (InternalServerErrorException) {
    InternalServerErrorException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(InternalServerErrorException || (InternalServerErrorException = {}));
export var MethodNotAllowedException;
(function (MethodNotAllowedException) {
    MethodNotAllowedException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MethodNotAllowedException || (MethodNotAllowedException = {}));
export var NotFoundException;
(function (NotFoundException) {
    NotFoundException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(NotFoundException || (NotFoundException = {}));
export var PayloadTooLargeException;
(function (PayloadTooLargeException) {
    PayloadTooLargeException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PayloadTooLargeException || (PayloadTooLargeException = {}));
export var TooManyRequestsException;
(function (TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(TooManyRequestsException || (TooManyRequestsException = {}));
export var WriteTreatmentResource;
(function (WriteTreatmentResource) {
    WriteTreatmentResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(WriteTreatmentResource || (WriteTreatmentResource = {}));
export var WriteCampaignRequest;
(function (WriteCampaignRequest) {
    WriteCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(WriteCampaignRequest || (WriteCampaignRequest = {}));
export var CreateCampaignRequest;
(function (CreateCampaignRequest) {
    CreateCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCampaignRequest || (CreateCampaignRequest = {}));
export var CreateCampaignResponse;
(function (CreateCampaignResponse) {
    CreateCampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateCampaignResponse || (CreateCampaignResponse = {}));
export var EmailTemplateRequest;
(function (EmailTemplateRequest) {
    EmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EmailTemplateRequest || (EmailTemplateRequest = {}));
export var CreateEmailTemplateRequest;
(function (CreateEmailTemplateRequest) {
    CreateEmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateEmailTemplateRequest || (CreateEmailTemplateRequest = {}));
export var CreateTemplateMessageBody;
(function (CreateTemplateMessageBody) {
    CreateTemplateMessageBody.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateTemplateMessageBody || (CreateTemplateMessageBody = {}));
export var CreateEmailTemplateResponse;
(function (CreateEmailTemplateResponse) {
    CreateEmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateEmailTemplateResponse || (CreateEmailTemplateResponse = {}));
export var ExportJobRequest;
(function (ExportJobRequest) {
    ExportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ExportJobRequest || (ExportJobRequest = {}));
export var CreateExportJobRequest;
(function (CreateExportJobRequest) {
    CreateExportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateExportJobRequest || (CreateExportJobRequest = {}));
export var ExportJobResource;
(function (ExportJobResource) {
    ExportJobResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ExportJobResource || (ExportJobResource = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["COMPLETING"] = "COMPLETING";
    JobStatus["CREATED"] = "CREATED";
    JobStatus["FAILED"] = "FAILED";
    JobStatus["FAILING"] = "FAILING";
    JobStatus["INITIALIZING"] = "INITIALIZING";
    JobStatus["PENDING_JOB"] = "PENDING_JOB";
    JobStatus["PREPARING_FOR_INITIALIZATION"] = "PREPARING_FOR_INITIALIZATION";
    JobStatus["PROCESSING"] = "PROCESSING";
})(JobStatus || (JobStatus = {}));
export var ExportJobResponse;
(function (ExportJobResponse) {
    ExportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ExportJobResponse || (ExportJobResponse = {}));
export var CreateExportJobResponse;
(function (CreateExportJobResponse) {
    CreateExportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateExportJobResponse || (CreateExportJobResponse = {}));
export var Format;
(function (Format) {
    Format["CSV"] = "CSV";
    Format["JSON"] = "JSON";
})(Format || (Format = {}));
export var ImportJobRequest;
(function (ImportJobRequest) {
    ImportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ImportJobRequest || (ImportJobRequest = {}));
export var CreateImportJobRequest;
(function (CreateImportJobRequest) {
    CreateImportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateImportJobRequest || (CreateImportJobRequest = {}));
export var ImportJobResource;
(function (ImportJobResource) {
    ImportJobResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ImportJobResource || (ImportJobResource = {}));
export var ImportJobResponse;
(function (ImportJobResponse) {
    ImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ImportJobResponse || (ImportJobResponse = {}));
export var CreateImportJobResponse;
(function (CreateImportJobResponse) {
    CreateImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateImportJobResponse || (CreateImportJobResponse = {}));
export var JourneyLimits;
(function (JourneyLimits) {
    JourneyLimits.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(JourneyLimits || (JourneyLimits = {}));
export var JourneySchedule;
(function (JourneySchedule) {
    JourneySchedule.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(JourneySchedule || (JourneySchedule = {}));
export var EventFilter;
(function (EventFilter) {
    EventFilter.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventFilter || (EventFilter = {}));
export var EventStartCondition;
(function (EventStartCondition) {
    EventStartCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventStartCondition || (EventStartCondition = {}));
export var StartCondition;
(function (StartCondition) {
    StartCondition.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(StartCondition || (StartCondition = {}));
export var State;
(function (State) {
    State["ACTIVE"] = "ACTIVE";
    State["CANCELLED"] = "CANCELLED";
    State["CLOSED"] = "CLOSED";
    State["COMPLETED"] = "COMPLETED";
    State["DRAFT"] = "DRAFT";
})(State || (State = {}));
export var WriteJourneyRequest;
(function (WriteJourneyRequest) {
    WriteJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(WriteJourneyRequest || (WriteJourneyRequest = {}));
export var CreateJourneyRequest;
(function (CreateJourneyRequest) {
    CreateJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateJourneyRequest || (CreateJourneyRequest = {}));
export var JourneyResponse;
(function (JourneyResponse) {
    JourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(JourneyResponse || (JourneyResponse = {}));
export var CreateJourneyResponse;
(function (CreateJourneyResponse) {
    CreateJourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateJourneyResponse || (CreateJourneyResponse = {}));
export var DefaultPushNotificationTemplate;
(function (DefaultPushNotificationTemplate) {
    DefaultPushNotificationTemplate.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DefaultPushNotificationTemplate || (DefaultPushNotificationTemplate = {}));
export var PushNotificationTemplateRequest;
(function (PushNotificationTemplateRequest) {
    PushNotificationTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PushNotificationTemplateRequest || (PushNotificationTemplateRequest = {}));
export var CreatePushTemplateRequest;
(function (CreatePushTemplateRequest) {
    CreatePushTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreatePushTemplateRequest || (CreatePushTemplateRequest = {}));
export var CreatePushTemplateResponse;
(function (CreatePushTemplateResponse) {
    CreatePushTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreatePushTemplateResponse || (CreatePushTemplateResponse = {}));
export var CreateRecommenderConfigurationShape;
(function (CreateRecommenderConfigurationShape) {
    CreateRecommenderConfigurationShape.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateRecommenderConfigurationShape || (CreateRecommenderConfigurationShape = {}));
export var CreateRecommenderConfigurationRequest;
(function (CreateRecommenderConfigurationRequest) {
    CreateRecommenderConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateRecommenderConfigurationRequest || (CreateRecommenderConfigurationRequest = {}));
export var RecommenderConfigurationResponse;
(function (RecommenderConfigurationResponse) {
    RecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RecommenderConfigurationResponse || (RecommenderConfigurationResponse = {}));
export var CreateRecommenderConfigurationResponse;
(function (CreateRecommenderConfigurationResponse) {
    CreateRecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateRecommenderConfigurationResponse || (CreateRecommenderConfigurationResponse = {}));
export var SegmentReference;
(function (SegmentReference) {
    SegmentReference.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentReference || (SegmentReference = {}));
export var SourceType;
(function (SourceType) {
    SourceType["ALL"] = "ALL";
    SourceType["ANY"] = "ANY";
    SourceType["NONE"] = "NONE";
})(SourceType || (SourceType = {}));
export var Type;
(function (Type) {
    Type["ALL"] = "ALL";
    Type["ANY"] = "ANY";
    Type["NONE"] = "NONE";
})(Type || (Type = {}));
export var SegmentGroup;
(function (SegmentGroup) {
    SegmentGroup.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentGroup || (SegmentGroup = {}));
export var Include;
(function (Include) {
    Include["ALL"] = "ALL";
    Include["ANY"] = "ANY";
    Include["NONE"] = "NONE";
})(Include || (Include = {}));
export var SegmentGroupList;
(function (SegmentGroupList) {
    SegmentGroupList.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentGroupList || (SegmentGroupList = {}));
export var WriteSegmentRequest;
(function (WriteSegmentRequest) {
    WriteSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(WriteSegmentRequest || (WriteSegmentRequest = {}));
export var CreateSegmentRequest;
(function (CreateSegmentRequest) {
    CreateSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateSegmentRequest || (CreateSegmentRequest = {}));
export var SegmentImportResource;
(function (SegmentImportResource) {
    SegmentImportResource.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentImportResource || (SegmentImportResource = {}));
export var SegmentType;
(function (SegmentType) {
    SegmentType["DIMENSIONAL"] = "DIMENSIONAL";
    SegmentType["IMPORT"] = "IMPORT";
})(SegmentType || (SegmentType = {}));
export var SegmentResponse;
(function (SegmentResponse) {
    SegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SegmentResponse || (SegmentResponse = {}));
export var CreateSegmentResponse;
(function (CreateSegmentResponse) {
    CreateSegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateSegmentResponse || (CreateSegmentResponse = {}));
export var SMSTemplateRequest;
(function (SMSTemplateRequest) {
    SMSTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SMSTemplateRequest || (SMSTemplateRequest = {}));
export var CreateSmsTemplateRequest;
(function (CreateSmsTemplateRequest) {
    CreateSmsTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateSmsTemplateRequest || (CreateSmsTemplateRequest = {}));
export var CreateSmsTemplateResponse;
(function (CreateSmsTemplateResponse) {
    CreateSmsTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateSmsTemplateResponse || (CreateSmsTemplateResponse = {}));
export var VoiceTemplateRequest;
(function (VoiceTemplateRequest) {
    VoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VoiceTemplateRequest || (VoiceTemplateRequest = {}));
export var CreateVoiceTemplateRequest;
(function (CreateVoiceTemplateRequest) {
    CreateVoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateVoiceTemplateRequest || (CreateVoiceTemplateRequest = {}));
export var CreateVoiceTemplateResponse;
(function (CreateVoiceTemplateResponse) {
    CreateVoiceTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(CreateVoiceTemplateResponse || (CreateVoiceTemplateResponse = {}));
export var DefaultMessage;
(function (DefaultMessage) {
    DefaultMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DefaultMessage || (DefaultMessage = {}));
export var DefaultPushNotificationMessage;
(function (DefaultPushNotificationMessage) {
    DefaultPushNotificationMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DefaultPushNotificationMessage || (DefaultPushNotificationMessage = {}));
export var DeleteAdmChannelRequest;
(function (DeleteAdmChannelRequest) {
    DeleteAdmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteAdmChannelRequest || (DeleteAdmChannelRequest = {}));
export var DeleteAdmChannelResponse;
(function (DeleteAdmChannelResponse) {
    DeleteAdmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteAdmChannelResponse || (DeleteAdmChannelResponse = {}));
export var DeleteApnsChannelRequest;
(function (DeleteApnsChannelRequest) {
    DeleteApnsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsChannelRequest || (DeleteApnsChannelRequest = {}));
export var DeleteApnsChannelResponse;
(function (DeleteApnsChannelResponse) {
    DeleteApnsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsChannelResponse || (DeleteApnsChannelResponse = {}));
export var DeleteApnsSandboxChannelRequest;
(function (DeleteApnsSandboxChannelRequest) {
    DeleteApnsSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsSandboxChannelRequest || (DeleteApnsSandboxChannelRequest = {}));
export var DeleteApnsSandboxChannelResponse;
(function (DeleteApnsSandboxChannelResponse) {
    DeleteApnsSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsSandboxChannelResponse || (DeleteApnsSandboxChannelResponse = {}));
export var DeleteApnsVoipChannelRequest;
(function (DeleteApnsVoipChannelRequest) {
    DeleteApnsVoipChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsVoipChannelRequest || (DeleteApnsVoipChannelRequest = {}));
export var DeleteApnsVoipChannelResponse;
(function (DeleteApnsVoipChannelResponse) {
    DeleteApnsVoipChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsVoipChannelResponse || (DeleteApnsVoipChannelResponse = {}));
export var DeleteApnsVoipSandboxChannelRequest;
(function (DeleteApnsVoipSandboxChannelRequest) {
    DeleteApnsVoipSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsVoipSandboxChannelRequest || (DeleteApnsVoipSandboxChannelRequest = {}));
export var DeleteApnsVoipSandboxChannelResponse;
(function (DeleteApnsVoipSandboxChannelResponse) {
    DeleteApnsVoipSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteApnsVoipSandboxChannelResponse || (DeleteApnsVoipSandboxChannelResponse = {}));
export var DeleteAppRequest;
(function (DeleteAppRequest) {
    DeleteAppRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteAppRequest || (DeleteAppRequest = {}));
export var DeleteAppResponse;
(function (DeleteAppResponse) {
    DeleteAppResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteAppResponse || (DeleteAppResponse = {}));
export var DeleteBaiduChannelRequest;
(function (DeleteBaiduChannelRequest) {
    DeleteBaiduChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteBaiduChannelRequest || (DeleteBaiduChannelRequest = {}));
export var DeleteBaiduChannelResponse;
(function (DeleteBaiduChannelResponse) {
    DeleteBaiduChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteBaiduChannelResponse || (DeleteBaiduChannelResponse = {}));
export var DeleteCampaignRequest;
(function (DeleteCampaignRequest) {
    DeleteCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteCampaignRequest || (DeleteCampaignRequest = {}));
export var DeleteCampaignResponse;
(function (DeleteCampaignResponse) {
    DeleteCampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteCampaignResponse || (DeleteCampaignResponse = {}));
export var DeleteEmailChannelRequest;
(function (DeleteEmailChannelRequest) {
    DeleteEmailChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEmailChannelRequest || (DeleteEmailChannelRequest = {}));
export var EmailChannelResponse;
(function (EmailChannelResponse) {
    EmailChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EmailChannelResponse || (EmailChannelResponse = {}));
export var DeleteEmailChannelResponse;
(function (DeleteEmailChannelResponse) {
    DeleteEmailChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEmailChannelResponse || (DeleteEmailChannelResponse = {}));
export var DeleteEmailTemplateRequest;
(function (DeleteEmailTemplateRequest) {
    DeleteEmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEmailTemplateRequest || (DeleteEmailTemplateRequest = {}));
export var MessageBody;
(function (MessageBody) {
    MessageBody.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(MessageBody || (MessageBody = {}));
export var DeleteEmailTemplateResponse;
(function (DeleteEmailTemplateResponse) {
    DeleteEmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEmailTemplateResponse || (DeleteEmailTemplateResponse = {}));
export var DeleteEndpointRequest;
(function (DeleteEndpointRequest) {
    DeleteEndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEndpointRequest || (DeleteEndpointRequest = {}));
export var EndpointDemographic;
(function (EndpointDemographic) {
    EndpointDemographic.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointDemographic || (EndpointDemographic = {}));
export var EndpointLocation;
(function (EndpointLocation) {
    EndpointLocation.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointLocation || (EndpointLocation = {}));
export var EndpointUser;
(function (EndpointUser) {
    EndpointUser.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointUser || (EndpointUser = {}));
export var EndpointResponse;
(function (EndpointResponse) {
    EndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointResponse || (EndpointResponse = {}));
export var DeleteEndpointResponse;
(function (DeleteEndpointResponse) {
    DeleteEndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEndpointResponse || (DeleteEndpointResponse = {}));
export var DeleteEventStreamRequest;
(function (DeleteEventStreamRequest) {
    DeleteEventStreamRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEventStreamRequest || (DeleteEventStreamRequest = {}));
export var EventStream;
(function (EventStream) {
    EventStream.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventStream || (EventStream = {}));
export var DeleteEventStreamResponse;
(function (DeleteEventStreamResponse) {
    DeleteEventStreamResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteEventStreamResponse || (DeleteEventStreamResponse = {}));
export var DeleteGcmChannelRequest;
(function (DeleteGcmChannelRequest) {
    DeleteGcmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteGcmChannelRequest || (DeleteGcmChannelRequest = {}));
export var GCMChannelResponse;
(function (GCMChannelResponse) {
    GCMChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GCMChannelResponse || (GCMChannelResponse = {}));
export var DeleteGcmChannelResponse;
(function (DeleteGcmChannelResponse) {
    DeleteGcmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteGcmChannelResponse || (DeleteGcmChannelResponse = {}));
export var DeleteJourneyRequest;
(function (DeleteJourneyRequest) {
    DeleteJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteJourneyRequest || (DeleteJourneyRequest = {}));
export var DeleteJourneyResponse;
(function (DeleteJourneyResponse) {
    DeleteJourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteJourneyResponse || (DeleteJourneyResponse = {}));
export var DeletePushTemplateRequest;
(function (DeletePushTemplateRequest) {
    DeletePushTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeletePushTemplateRequest || (DeletePushTemplateRequest = {}));
export var DeletePushTemplateResponse;
(function (DeletePushTemplateResponse) {
    DeletePushTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeletePushTemplateResponse || (DeletePushTemplateResponse = {}));
export var DeleteRecommenderConfigurationRequest;
(function (DeleteRecommenderConfigurationRequest) {
    DeleteRecommenderConfigurationRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteRecommenderConfigurationRequest || (DeleteRecommenderConfigurationRequest = {}));
export var DeleteRecommenderConfigurationResponse;
(function (DeleteRecommenderConfigurationResponse) {
    DeleteRecommenderConfigurationResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteRecommenderConfigurationResponse || (DeleteRecommenderConfigurationResponse = {}));
export var DeleteSegmentRequest;
(function (DeleteSegmentRequest) {
    DeleteSegmentRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteSegmentRequest || (DeleteSegmentRequest = {}));
export var DeleteSegmentResponse;
(function (DeleteSegmentResponse) {
    DeleteSegmentResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteSegmentResponse || (DeleteSegmentResponse = {}));
export var DeleteSmsChannelRequest;
(function (DeleteSmsChannelRequest) {
    DeleteSmsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteSmsChannelRequest || (DeleteSmsChannelRequest = {}));
export var SMSChannelResponse;
(function (SMSChannelResponse) {
    SMSChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SMSChannelResponse || (SMSChannelResponse = {}));
export var DeleteSmsChannelResponse;
(function (DeleteSmsChannelResponse) {
    DeleteSmsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteSmsChannelResponse || (DeleteSmsChannelResponse = {}));
export var DeleteSmsTemplateRequest;
(function (DeleteSmsTemplateRequest) {
    DeleteSmsTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteSmsTemplateRequest || (DeleteSmsTemplateRequest = {}));
export var DeleteSmsTemplateResponse;
(function (DeleteSmsTemplateResponse) {
    DeleteSmsTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteSmsTemplateResponse || (DeleteSmsTemplateResponse = {}));
export var DeleteUserEndpointsRequest;
(function (DeleteUserEndpointsRequest) {
    DeleteUserEndpointsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteUserEndpointsRequest || (DeleteUserEndpointsRequest = {}));
export var EndpointsResponse;
(function (EndpointsResponse) {
    EndpointsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointsResponse || (EndpointsResponse = {}));
export var DeleteUserEndpointsResponse;
(function (DeleteUserEndpointsResponse) {
    DeleteUserEndpointsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteUserEndpointsResponse || (DeleteUserEndpointsResponse = {}));
export var DeleteVoiceChannelRequest;
(function (DeleteVoiceChannelRequest) {
    DeleteVoiceChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteVoiceChannelRequest || (DeleteVoiceChannelRequest = {}));
export var VoiceChannelResponse;
(function (VoiceChannelResponse) {
    VoiceChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VoiceChannelResponse || (VoiceChannelResponse = {}));
export var DeleteVoiceChannelResponse;
(function (DeleteVoiceChannelResponse) {
    DeleteVoiceChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteVoiceChannelResponse || (DeleteVoiceChannelResponse = {}));
export var DeleteVoiceTemplateRequest;
(function (DeleteVoiceTemplateRequest) {
    DeleteVoiceTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteVoiceTemplateRequest || (DeleteVoiceTemplateRequest = {}));
export var DeleteVoiceTemplateResponse;
(function (DeleteVoiceTemplateResponse) {
    DeleteVoiceTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DeleteVoiceTemplateResponse || (DeleteVoiceTemplateResponse = {}));
export var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["DUPLICATE"] = "DUPLICATE";
    DeliveryStatus["OPT_OUT"] = "OPT_OUT";
    DeliveryStatus["PERMANENT_FAILURE"] = "PERMANENT_FAILURE";
    DeliveryStatus["SUCCESSFUL"] = "SUCCESSFUL";
    DeliveryStatus["TEMPORARY_FAILURE"] = "TEMPORARY_FAILURE";
    DeliveryStatus["THROTTLED"] = "THROTTLED";
    DeliveryStatus["UNKNOWN_FAILURE"] = "UNKNOWN_FAILURE";
})(DeliveryStatus || (DeliveryStatus = {}));
export var RawEmail;
(function (RawEmail) {
    RawEmail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(RawEmail || (RawEmail = {}));
export var SimpleEmailPart;
(function (SimpleEmailPart) {
    SimpleEmailPart.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SimpleEmailPart || (SimpleEmailPart = {}));
export var SimpleEmail;
(function (SimpleEmail) {
    SimpleEmail.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SimpleEmail || (SimpleEmail = {}));
export var EmailMessage;
(function (EmailMessage) {
    EmailMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EmailMessage || (EmailMessage = {}));
export var GCMMessage;
(function (GCMMessage) {
    GCMMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GCMMessage || (GCMMessage = {}));
export var SMSMessage;
(function (SMSMessage) {
    SMSMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(SMSMessage || (SMSMessage = {}));
export var VoiceMessage;
(function (VoiceMessage) {
    VoiceMessage.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(VoiceMessage || (VoiceMessage = {}));
export var DirectMessageConfiguration;
(function (DirectMessageConfiguration) {
    DirectMessageConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(DirectMessageConfiguration || (DirectMessageConfiguration = {}));
export var EmailChannelRequest;
(function (EmailChannelRequest) {
    EmailChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EmailChannelRequest || (EmailChannelRequest = {}));
export var TemplateType;
(function (TemplateType) {
    TemplateType["EMAIL"] = "EMAIL";
    TemplateType["PUSH"] = "PUSH";
    TemplateType["SMS"] = "SMS";
    TemplateType["VOICE"] = "VOICE";
})(TemplateType || (TemplateType = {}));
export var EmailTemplateResponse;
(function (EmailTemplateResponse) {
    EmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EmailTemplateResponse || (EmailTemplateResponse = {}));
export var EndpointBatchItem;
(function (EndpointBatchItem) {
    EndpointBatchItem.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointBatchItem || (EndpointBatchItem = {}));
export var EndpointBatchRequest;
(function (EndpointBatchRequest) {
    EndpointBatchRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointBatchRequest || (EndpointBatchRequest = {}));
export var EndpointItemResponse;
(function (EndpointItemResponse) {
    EndpointItemResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointItemResponse || (EndpointItemResponse = {}));
export var EndpointMessageResult;
(function (EndpointMessageResult) {
    EndpointMessageResult.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointMessageResult || (EndpointMessageResult = {}));
export var EndpointRequest;
(function (EndpointRequest) {
    EndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointRequest || (EndpointRequest = {}));
export var EndpointSendConfiguration;
(function (EndpointSendConfiguration) {
    EndpointSendConfiguration.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EndpointSendConfiguration || (EndpointSendConfiguration = {}));
export var Session;
(function (Session) {
    Session.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Session || (Session = {}));
export var Event;
(function (Event) {
    Event.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(Event || (Event = {}));
export var EventItemResponse;
(function (EventItemResponse) {
    EventItemResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventItemResponse || (EventItemResponse = {}));
export var PublicEndpoint;
(function (PublicEndpoint) {
    PublicEndpoint.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(PublicEndpoint || (PublicEndpoint = {}));
export var EventsBatch;
(function (EventsBatch) {
    EventsBatch.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventsBatch || (EventsBatch = {}));
export var EventsRequest;
(function (EventsRequest) {
    EventsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventsRequest || (EventsRequest = {}));
export var ItemResponse;
(function (ItemResponse) {
    ItemResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ItemResponse || (ItemResponse = {}));
export var EventsResponse;
(function (EventsResponse) {
    EventsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(EventsResponse || (EventsResponse = {}));
export var ExportJobsResponse;
(function (ExportJobsResponse) {
    ExportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ExportJobsResponse || (ExportJobsResponse = {}));
export var GCMChannelRequest;
(function (GCMChannelRequest) {
    GCMChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GCMChannelRequest || (GCMChannelRequest = {}));
export var GetAdmChannelRequest;
(function (GetAdmChannelRequest) {
    GetAdmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAdmChannelRequest || (GetAdmChannelRequest = {}));
export var GetAdmChannelResponse;
(function (GetAdmChannelResponse) {
    GetAdmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAdmChannelResponse || (GetAdmChannelResponse = {}));
export var GetApnsChannelRequest;
(function (GetApnsChannelRequest) {
    GetApnsChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsChannelRequest || (GetApnsChannelRequest = {}));
export var GetApnsChannelResponse;
(function (GetApnsChannelResponse) {
    GetApnsChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsChannelResponse || (GetApnsChannelResponse = {}));
export var GetApnsSandboxChannelRequest;
(function (GetApnsSandboxChannelRequest) {
    GetApnsSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsSandboxChannelRequest || (GetApnsSandboxChannelRequest = {}));
export var GetApnsSandboxChannelResponse;
(function (GetApnsSandboxChannelResponse) {
    GetApnsSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsSandboxChannelResponse || (GetApnsSandboxChannelResponse = {}));
export var GetApnsVoipChannelRequest;
(function (GetApnsVoipChannelRequest) {
    GetApnsVoipChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsVoipChannelRequest || (GetApnsVoipChannelRequest = {}));
export var GetApnsVoipChannelResponse;
(function (GetApnsVoipChannelResponse) {
    GetApnsVoipChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsVoipChannelResponse || (GetApnsVoipChannelResponse = {}));
export var GetApnsVoipSandboxChannelRequest;
(function (GetApnsVoipSandboxChannelRequest) {
    GetApnsVoipSandboxChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsVoipSandboxChannelRequest || (GetApnsVoipSandboxChannelRequest = {}));
export var GetApnsVoipSandboxChannelResponse;
(function (GetApnsVoipSandboxChannelResponse) {
    GetApnsVoipSandboxChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApnsVoipSandboxChannelResponse || (GetApnsVoipSandboxChannelResponse = {}));
export var GetAppRequest;
(function (GetAppRequest) {
    GetAppRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAppRequest || (GetAppRequest = {}));
export var GetAppResponse;
(function (GetAppResponse) {
    GetAppResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAppResponse || (GetAppResponse = {}));
export var GetApplicationDateRangeKpiRequest;
(function (GetApplicationDateRangeKpiRequest) {
    GetApplicationDateRangeKpiRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApplicationDateRangeKpiRequest || (GetApplicationDateRangeKpiRequest = {}));
export var GetApplicationDateRangeKpiResponse;
(function (GetApplicationDateRangeKpiResponse) {
    GetApplicationDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApplicationDateRangeKpiResponse || (GetApplicationDateRangeKpiResponse = {}));
export var GetApplicationSettingsRequest;
(function (GetApplicationSettingsRequest) {
    GetApplicationSettingsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApplicationSettingsRequest || (GetApplicationSettingsRequest = {}));
export var GetApplicationSettingsResponse;
(function (GetApplicationSettingsResponse) {
    GetApplicationSettingsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetApplicationSettingsResponse || (GetApplicationSettingsResponse = {}));
export var GetAppsRequest;
(function (GetAppsRequest) {
    GetAppsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAppsRequest || (GetAppsRequest = {}));
export var GetAppsResponse;
(function (GetAppsResponse) {
    GetAppsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetAppsResponse || (GetAppsResponse = {}));
export var GetBaiduChannelRequest;
(function (GetBaiduChannelRequest) {
    GetBaiduChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetBaiduChannelRequest || (GetBaiduChannelRequest = {}));
export var GetBaiduChannelResponse;
(function (GetBaiduChannelResponse) {
    GetBaiduChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetBaiduChannelResponse || (GetBaiduChannelResponse = {}));
export var GetCampaignRequest;
(function (GetCampaignRequest) {
    GetCampaignRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignRequest || (GetCampaignRequest = {}));
export var GetCampaignResponse;
(function (GetCampaignResponse) {
    GetCampaignResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignResponse || (GetCampaignResponse = {}));
export var GetCampaignActivitiesRequest;
(function (GetCampaignActivitiesRequest) {
    GetCampaignActivitiesRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignActivitiesRequest || (GetCampaignActivitiesRequest = {}));
export var GetCampaignActivitiesResponse;
(function (GetCampaignActivitiesResponse) {
    GetCampaignActivitiesResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignActivitiesResponse || (GetCampaignActivitiesResponse = {}));
export var GetCampaignDateRangeKpiRequest;
(function (GetCampaignDateRangeKpiRequest) {
    GetCampaignDateRangeKpiRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignDateRangeKpiRequest || (GetCampaignDateRangeKpiRequest = {}));
export var GetCampaignDateRangeKpiResponse;
(function (GetCampaignDateRangeKpiResponse) {
    GetCampaignDateRangeKpiResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignDateRangeKpiResponse || (GetCampaignDateRangeKpiResponse = {}));
export var GetCampaignsRequest;
(function (GetCampaignsRequest) {
    GetCampaignsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignsRequest || (GetCampaignsRequest = {}));
export var GetCampaignsResponse;
(function (GetCampaignsResponse) {
    GetCampaignsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignsResponse || (GetCampaignsResponse = {}));
export var GetCampaignVersionRequest;
(function (GetCampaignVersionRequest) {
    GetCampaignVersionRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignVersionRequest || (GetCampaignVersionRequest = {}));
export var GetCampaignVersionResponse;
(function (GetCampaignVersionResponse) {
    GetCampaignVersionResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignVersionResponse || (GetCampaignVersionResponse = {}));
export var GetCampaignVersionsRequest;
(function (GetCampaignVersionsRequest) {
    GetCampaignVersionsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignVersionsRequest || (GetCampaignVersionsRequest = {}));
export var GetCampaignVersionsResponse;
(function (GetCampaignVersionsResponse) {
    GetCampaignVersionsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetCampaignVersionsResponse || (GetCampaignVersionsResponse = {}));
export var GetChannelsRequest;
(function (GetChannelsRequest) {
    GetChannelsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetChannelsRequest || (GetChannelsRequest = {}));
export var GetChannelsResponse;
(function (GetChannelsResponse) {
    GetChannelsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetChannelsResponse || (GetChannelsResponse = {}));
export var GetEmailChannelRequest;
(function (GetEmailChannelRequest) {
    GetEmailChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEmailChannelRequest || (GetEmailChannelRequest = {}));
export var GetEmailChannelResponse;
(function (GetEmailChannelResponse) {
    GetEmailChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEmailChannelResponse || (GetEmailChannelResponse = {}));
export var GetEmailTemplateRequest;
(function (GetEmailTemplateRequest) {
    GetEmailTemplateRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEmailTemplateRequest || (GetEmailTemplateRequest = {}));
export var GetEmailTemplateResponse;
(function (GetEmailTemplateResponse) {
    GetEmailTemplateResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEmailTemplateResponse || (GetEmailTemplateResponse = {}));
export var GetEndpointRequest;
(function (GetEndpointRequest) {
    GetEndpointRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEndpointRequest || (GetEndpointRequest = {}));
export var GetEndpointResponse;
(function (GetEndpointResponse) {
    GetEndpointResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEndpointResponse || (GetEndpointResponse = {}));
export var GetEventStreamRequest;
(function (GetEventStreamRequest) {
    GetEventStreamRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEventStreamRequest || (GetEventStreamRequest = {}));
export var GetEventStreamResponse;
(function (GetEventStreamResponse) {
    GetEventStreamResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetEventStreamResponse || (GetEventStreamResponse = {}));
export var GetExportJobRequest;
(function (GetExportJobRequest) {
    GetExportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetExportJobRequest || (GetExportJobRequest = {}));
export var GetExportJobResponse;
(function (GetExportJobResponse) {
    GetExportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetExportJobResponse || (GetExportJobResponse = {}));
export var GetExportJobsRequest;
(function (GetExportJobsRequest) {
    GetExportJobsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetExportJobsRequest || (GetExportJobsRequest = {}));
export var GetExportJobsResponse;
(function (GetExportJobsResponse) {
    GetExportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetExportJobsResponse || (GetExportJobsResponse = {}));
export var GetGcmChannelRequest;
(function (GetGcmChannelRequest) {
    GetGcmChannelRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetGcmChannelRequest || (GetGcmChannelRequest = {}));
export var GetGcmChannelResponse;
(function (GetGcmChannelResponse) {
    GetGcmChannelResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetGcmChannelResponse || (GetGcmChannelResponse = {}));
export var GetImportJobRequest;
(function (GetImportJobRequest) {
    GetImportJobRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetImportJobRequest || (GetImportJobRequest = {}));
export var GetImportJobResponse;
(function (GetImportJobResponse) {
    GetImportJobResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetImportJobResponse || (GetImportJobResponse = {}));
export var GetImportJobsRequest;
(function (GetImportJobsRequest) {
    GetImportJobsRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetImportJobsRequest || (GetImportJobsRequest = {}));
export var ImportJobsResponse;
(function (ImportJobsResponse) {
    ImportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(ImportJobsResponse || (ImportJobsResponse = {}));
export var GetImportJobsResponse;
(function (GetImportJobsResponse) {
    GetImportJobsResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetImportJobsResponse || (GetImportJobsResponse = {}));
export var GetJourneyRequest;
(function (GetJourneyRequest) {
    GetJourneyRequest.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetJourneyRequest || (GetJourneyRequest = {}));
export var GetJourneyResponse;
(function (GetJourneyResponse) {
    GetJourneyResponse.filterSensitiveLog = function (obj) { return (__assign({}, obj)); };
})(GetJourneyResponse || (GetJourneyResponse = {}));
//# sourceMappingURL=models_0.js.map